// extracted by mini-css-extract-plugin
export const banner = "gdpr-module--banner--1QP4d";
export const content = "gdpr-module--content--2jqEy";
export const preferences = "gdpr-module--preferences--1d0Jm";
export const preferencesLabel = "gdpr-module--preferencesLabel--2M96V";
export const preferenceOption = "gdpr-module--preferenceOption--3GCOZ";
export const buttons = "gdpr-module--buttons--10kqd";
export const button = "gdpr-module--button--2JOBl";
export const declineButton = "gdpr-module--declineButton--DWYuw";
export const preferencesButton = "gdpr-module--preferencesButton--2V07x";
export const preferencesButtonActive = "gdpr-module--preferencesButtonActive--2-xSo";